const bladder_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].TextField12[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"F[0].Page_1[0].Yes[3]",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"F[0].Page_1[0].No[3]",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_1[0].Yes[2]",
      "dbqName_no":"F[0].Page_1[0].No[2]",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_1[0].Yes[5]",
      "dbqName_no":"F[0].Page_1[0].Yes[4]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].TextField13[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## have a Voiding Dysfunction?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "VOIDING DYSFUNCTION",
         number: "3"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_1[0].Yes1[0]",
      "dbqName_no":"F[0].Page_1[0].No1[0]",
      "answer":"",
   },
   {
      "question":"Etiology of voiding dysfunction",
      "sub":"",
      "type":"textarea",
      "maxLength":55,
      "show": true,
      "refId":1,
      "section": {
         page: "1",
         title: "VOIDING DYSFUNCTION",
         number: "3A"
      },
      "dbqName":"F[0].Page_1[0].Otherdescribe[0]",
      "answer":""
   },

   {
      "question":"Does the Voiding Dysfunction cause urine leakage?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "3C"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].Yes2[0]",
      "dbqName_no":"F[0].Page_2[0].No2[0]",
      "answer":"",
   },
   {
      "question":"If voiding dysfunction cause urine leakage",
      "sub":"Please indicate the severity",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "textarea": false,
      "small": true,
      "refId":1,
      "cols": 2,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "3C"
      },
      "questions":[
         {
            "main":"Does not require the wearing of absorbent material",
            "dbqName":"F[0].Page_2[0].Severity1[0]",
            "answer":"",
         },
         {
            "main":"Requires absorbent material which must be changed less than 2 times per day",
            "dbqName":"F[0].Page_2[0].Severity2[0]",
            "answer":"",
         },
         {
            "main":"Requires absorbent material which must be changed 2 to 4 times per day",
            "dbqName":"F[0].Page_2[0].Severity3[0]",
            "answer":"",
         },
         {
            "main":"Requires absorbent material which must be changed more than 4 times per day",
            "dbqName":"F[0].Page_2[0].Severity4[0]",
            "answer":"",
         },
         {
            "main":"Other",
            "dbqName":"F[0].Page_2[0].Severity5[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "F[0].Page_2[0].Otherdescribe[0]",
            "placeholder": "Describe the frequency and severity",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Does the voiding dysfunction require the use of an Appliance?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "3D"
      },
      "maxLength":20,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_2[0].Yes3[0]",
      "dbqName_no":"F[0].Page_2[0].No3[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the appliance",
      "textdbqName":"F[0].Page_2[0].DescribeAppliance[0]",
      "textanswer":""
   },

   {
      "question":"Does the Voiding Dysfunction cause increased urinary frequency?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "3E"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].Yes4[0]",
      "dbqName_no":"F[0].Page_2[0].No4[0]",
      "answer":"",
   },
   {
      "question":"If voiding dysfunction cause increased urinary frequency",
      "sub":"Check all the apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "textarea": false,
      "small": true,
      "refId":1,
      "cols": 2,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "3E"
      },
      "questions":[
         {
            "main":"Daytime voiding interval less than 1 hour",
            "dbqName":"F[0].Page_2[0].Frequency1[0]",
            "answer":"",
         },
         {
            "main":"Daytime voiding interval between 1 and 2 hours",
            "dbqName":"F[0].Page_2[0].Frequency2[0]",
            "answer":"",
         },
         {
            "main":"Daytime voiding interval between 2 and 3 hours",
            "dbqName":"F[0].Page_2[0].Frequency3[0]",
            "answer":"",
         },
         {
            "main":"Nighttime awakening to void 2 times",
            "dbqName":"F[0].Page_2[0].Frequency4[0]",
            "answer":"",
         },
         {
            "main":"Nighttime awakening to void 3 to 4 times",
            "dbqName":"F[0].Page_2[0].Frequency5[0]",
            "answer":"",
         },
         {
            "main":"Nighttime awakening to void 5 or more times",
            "dbqName":"F[0].Page_2[0].Frequency6[0]",
            "answer":"",
         }
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":330,
      "show": true,
      "section": {
         page: "4",
         title: "REMARKS",
         number: "11A"
      },
      "options":[],
      "dbqName":"F[0].Page_4[0].Remarks[0]",
      "answer":""
   },
]
   
    export default bladder_questions ;